import {
  CLEAR_MULTIDAY_FORM,
  HIDE_CHILD_MISSING_TERMS_POPUP,
  HIDE_JOBS_INVITE_POPUP,
  SHOW_CHILD_MISSING_TERMS_POPUP,
  SHOW_JOBS_INVITE_CONFIRMATION_POPUP,
  SHOW_JOBS_INVITE_SELECTION_POPUP,
} from '~/actions';
import { IMultiDayState, TMultiDayAction } from './interface';

const initialState: IMultiDayState = {
  jobDates: null,
  jobInfo: [],
  jobsInvitePopup: {
    showConfirmation: false,
    showSelection: false,
    jobIds: [],
    profession: undefined,
    officeId: '',
  },
  isTCMissing: false,
  isPSAMissing: false,
  officeId: '',
};

export default (state: IMultiDayState = initialState, action: TMultiDayAction): IMultiDayState => {
  switch (action.type) {
    case CLEAR_MULTIDAY_FORM:
    case 'MULTIDAY_BOOKING_POST_SUCCESS':
      return {
        ...state,
        jobInfo: [],
        jobDates: null,
        isTCMissing: false,
        isPSAMissing: false,
        officeId: '',
      };
    case SHOW_JOBS_INVITE_CONFIRMATION_POPUP: {
      const { jobIds, profession, officeId } = action.payload;
      return {
        ...state,
        jobsInvitePopup: {
          ...state.jobsInvitePopup,
          showConfirmation: true,
          jobIds,
          profession,
          officeId,
        },
      };
    }
    case SHOW_JOBS_INVITE_SELECTION_POPUP:
      return {
        ...state,
        jobsInvitePopup: {
          ...state.jobsInvitePopup,
          showConfirmation: false,
          showSelection: true,
        },
      };
    case HIDE_JOBS_INVITE_POPUP:
      return {
        ...state,
        jobsInvitePopup: {
          ...state.jobsInvitePopup,
          showConfirmation: false,
          showSelection: false,
          jobIds: [],
          profession: undefined,
          officeId: '',
        },
      };

    case SHOW_CHILD_MISSING_TERMS_POPUP: {
      const { payload } = action;
      return {
        ...state,
        isTCMissing: payload.isTCMissing,
        isPSAMissing: payload.isPSAMissing,
        officeId: payload.officeId,
      };
    }
    case HIDE_CHILD_MISSING_TERMS_POPUP: {
      return {
        ...state,
        isTCMissing: false,
        isPSAMissing: false,
        officeId: '',
      };
    }

    default:
      return { ...state };
  }
};
